import { mapActions } from 'vuex'
import store from '@/store'

export default {
  data() {
    return {
      loginMessage: ''
    }
  },
  methods: {
    ...mapActions(['resetState'])
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('app/getXCsrfToken')
    next()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-saml-error/page-saml-error.js